const firebaseConfig = {
    apiKey: "AIzaSyAJtkBjUbWEI8v74c37uIbZjp2MWy75VhY",
    authDomain: "athu-login.firebaseapp.com",
    projectId: "athu-login",
    storageBucket: "athu-login.appspot.com",
    messagingSenderId: "331559036872",
    appId: "1:331559036872:web:ee5bf32fc7c5507198c2fd"
  };
 

  export default firebaseConfig;